
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recommend",
      function () {
        return require("private-next-pages/recommend/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recommend"])
      });
    }
  